import { useMemo } from 'react'

import { StyledContent } from '@/components/common/StyledContent'
import { ParsedContentProvider, useParsedContent } from '@/components/providers/ParsedContentProvider'
import { type QuillOpType } from '@/defs/misc'

import { parseQuillDelta } from './parseQuillDelta'

type Props = {
  deltaOps: QuillOpType[]
}

export const DescriptionQuill = ({ deltaOps }: Props) => {
  const content = useMemo(() => parseQuillDelta({ deltaOps }), [deltaOps])

  if (!content) return null

  return (
    <ParsedContentProvider content={content}>
      <DescriptionQuillInner />
    </ParsedContentProvider>
  )
}

const DescriptionQuillInner = () => {
  const { content } = useParsedContent()

  if (!content) return null

  return <StyledContent>{content}</StyledContent>
}
